<template lang="pug">
  app-toolbar(title="Статистика о постановлениях")
    app-toolbar-item-period-short.ml-12(@select="handlePeriod") {{ statperiod ? statperiod.text : 'все' }} 
    app-dialog-loading(v-model="updating")
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { $_app_moment } from "@/common/AppMoment.js"

import { AppDialogLoading } from '@/components'

import moment from 'moment'
moment.locale('ru')

export default {
  components: {
    [AppDialogLoading.name]: AppDialogLoading
  },
  mixins: [ $_app_moment ],
  data() {
    return {
      loading: false,
    }
  },

  computed: {
    ...mapState('gsu', ['statperiod', 'updating']),
  },

  methods: {
    ...mapMutations('gsu', [ 'setStatPeriod' ]),

    handlePeriod (item) {
      let load = (this.statperiod.start!=item.start || this.statperiod.end!=item.end)? true : false
      this.setStatPeriod(item)
      if(load) this.$store.dispatch('gsu/LOAD_STAT')
    },

  },

}
</script>


<style lang="scss" scoped>
  .sud-card-text {
    background: #FFFFFF; 
  }

  .sud-case-status-color {
    margin: 0 16px 0 0;
  }
</style>
